
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/[publisherSlug]/[journalSlug]/v2",
      function () {
        return require("private-next-pages/partner/[publisherSlug]/[journalSlug]/v2/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/[publisherSlug]/[journalSlug]/v2"])
      });
    }
  